import { COMBO_ANIM_BASE_OPACITY } from "@library/constants";
import styled, { css } from "styled-components";

export const RichTextElement = styled.div<{ width: number }>`
  &.content {
    /* text-align: inherit; */
    width: ${(props) => props.width || 100}%;
    @media screen and (max-width: 768px) {
      width: 100%;
    }
  }
`;

interface WrapperProps {
  $horizontalAlignment?: string;
  $amountOfLines?: number;
  $animation?: null | {
    speed: string;
    baseOpacity: string;
  };
}

export const StyledRichTextWrapper = styled.div<WrapperProps>`
  display: flex;
  align-items: center;
  justify-content: ${({ $horizontalAlignment = "inherit" }) =>
    $horizontalAlignment};
  width: 100%;
  position: relative;

  ${({ $animation }) => {
    if (!$animation) return;
    return css`
      --fr-anim-dur: 400ms;
      --fr-anim-delay: 0ms;

      span[data-highlight-active] {
        --fr-hi-additional-delay: calc(
          var(--fr-anim-delay) + var(--fr-anim-dur)
        );
      }
      span[data-rkpi-active] {
        --fr-rkpi-additional-delay: calc(
          var(--fr-anim-delay) + var(--fr-anim-dur)
        );
      }

      p,
      h1,
      h2,
      h3,
      li {
        opacity: ${Number($animation.baseOpacity ?? COMBO_ANIM_BASE_OPACITY) /
        100};
      }

      &[data-is-animation-active="true"] {
        p,
        h1,
        h2,
        h3,
        li {
          opacity: 1;
          transition: opacity var(--fr-anim-dur) var(--fr-anim-delay) ease;
        }
      }
    `;
  }}
`;

export const StyledFroalaEditorWrapper = styled(StyledRichTextWrapper)``;
